import React, { memo, useCallback } from 'react'

import { useNavigation, useRoute } from '@react-navigation/native'
import { BTN_SM, XStack } from '@zet/design-system'

import ZetLogo from '../../assets/icons/zetLogo'
import { bmsRedirectionLink } from '../../utils/constants'

interface IProps {
  bgColor?: string
  logoColor?: string
  btnColor?: string
  btnTextColor?: string
  showBackBtn?: boolean
}

export const CustomHeader: React.FC<IProps> = memo(
  ({
    bgColor = '#fff',
    logoColor = '#fff',
    btnColor,
    btnTextColor = '#fff',
    showBackBtn = true,
  }) => {
    const route = useRoute()
    const navigation = useNavigation()

    const handleOnPress = useCallback(() => {
      if (route?.name === 'QuickCustomerDetails') {
        window.location.href = bmsRedirectionLink
      } else {
        if (navigation.canGoBack()) {
          navigation.goBack()
        } else {
          window.history.back()
        }
      }
    }, [])

    return (
      <XStack
        style={{
          backgroundColor: bgColor,
        }}
        className="sticky top-0 z-10 h-8 items-center justify-between  px-4"
      >
        <ZetLogo color={logoColor} />
        {showBackBtn ? (
          <BTN_SM
            style={{
              backgroundColor: btnColor,
              color: btnTextColor,
              paddingHorizontal: 8,
              borderRadius: 4,
            }}
            onPress={handleOnPress}
          >
            Go Back
          </BTN_SM>
        ) : (
          <></>
        )}
      </XStack>
    )
  }
)
